import { Record } from 'immutable';
import { UNKNOWN_REMOVAL } from '../constants/overlayTypes';
const UnknownRemovalOverlay = Record({
  type: UNKNOWN_REMOVAL,
  audit: null
}, 'UnknownRemovalOverlay');
export default UnknownRemovalOverlay;